<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const src = computed(() => `/celebrations/${props.name}.webm`)
</script>

<template>
  <video
    :src="src"
    autoplay
    loop
    class="absolute bottom-11 left-1/2 z-20 -translate-x-1/2"
    style="width: 200px; height: auto"
  />
</template>
